
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    header: {
        height: '64px',
        '@media (min-width: 744px)': {
            height: '80px' // different to line up with express nav
        }
    },
    headerController: {
        width: '100%',
        backgroundColor: '#FFF'
    },
    headerController_fixed: {
        position: 'fixed',
        zIndex: 52
    },
    contentFloating: {
        backgroundColor: 'transparent',
        borderBottom: 'none',
        position: 'absolute',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px'
    },
    containerRelative: {
        position: 'relative',
        zIndex: 5
    },
    containerTable: {
        display: 'table',
        width: '100%',
        height: '100%'
    },
    containerTableChildCellAlignMiddle: {
        display: 'table-cell',
        verticalAlign: 'middle'
    },
    containerTableChildCellMiddleAlignMiddle: {
        display: 'table-cell',
        width: '100%',
        verticalAlign: 'middle'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Header/styles.js